import { render, staticRenderFns } from "./work.vue?vue&type=template&id=7286ac04"
import script from "./work.vue?vue&type=script&lang=ts"
export * from "./work.vue?vue&type=script&lang=ts"
import style0 from "./work.vue?vue&type=style&index=0&id=7286ac04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports